module.exports = __webpack_public_path__ + "img/cash.42b235f9.svg";